import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconArrowUpRightSvg } from "./IconArrowUpRightSvg.mjs";
const IconArrowUpRight = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconArrowUpRightSvg, ...iconProps });
};
export {
  IconArrowUpRight
};
